import GlossaryComponent from 'components/GlossaryComponent';
import React from 'react';
export default {
  GlossaryComponent,
  React
};